import { queryOptions, useQuery } from "@tanstack/react-query";

import { drillBlastReferenceAjax } from "../../ajax/DrillBlastReferenceAjax";
import { ErrorResponse } from "../../DTOs/Common/ErrorResponse";
import { DrillBitSizeDTO, DrillBlastLookupDTO } from "../../DTOs/DrillBlast/DrillBlastLookupDTO";

// Note: a failed fetch throws rather than returning [], so offline it cannot replace the list the prefetch cached.
const lookupQuery = <T,>(key: string, load: () => Promise<unknown>) => queryOptions({
  queryKey: ['references', 'drillBlast', key],
  queryFn: async () => {
    const res = await load();
    if (ErrorResponse.isErrorResponse(res)) throw new Error(`Failed to load ${key}`);
    return (res as { data: T[] }).data;
  },
  staleTime: 5 * 60 * 1000,
});

export const bitSizesQuery = lookupQuery<DrillBitSizeDTO>('bitSizes', () => drillBlastReferenceAjax.getBitSizes());
export const holeTypesQuery = lookupQuery<DrillBlastLookupDTO>('holeTypes', () => drillBlastReferenceAjax.getHoleTypes());
export const blastTypesQuery = lookupQuery<DrillBlastLookupDTO>('blastTypes', () => drillBlastReferenceAjax.getBlastTypes());
export const geoDrillingTypesQuery = lookupQuery<DrillBlastLookupDTO>('geoDrillingTypes', () => drillBlastReferenceAjax.getGeoDrillingTypes());

export function useBitSizes() {
  return useQuery(bitSizesQuery).data ?? [];
}

export function useHoleTypes() {
  return useQuery(holeTypesQuery).data ?? [];
}

export function useBlastTypes() {
  return useQuery(blastTypesQuery).data ?? [];
}

export function useGeoDrillingTypes() {
  return useQuery(geoDrillingTypesQuery).data ?? [];
}
